(() => {
  function init(panel) {
    if (panel.dataset.rodReady) return;
    const section = panel.closest('[data-section-type="product"]');
    if (!section) return;
    let facts;
    try { facts = JSON.parse(panel.querySelector('[data-rod-facts]').textContent); } catch { return; }
    panel.dataset.rodReady = 'true';
    const preserved = new URLSearchParams(window.location.search);
    function update(variant) {
      const data = variant && facts[String(variant.id)];
      panel.hidden = !data?.verified;
      if (!data?.verified) return;
      panel.querySelector('[data-rod-model]').textContent = data.model;
      panel.querySelectorAll('[data-rod-row]').forEach(row => {
        const key = row.dataset.rodRow;
        const value = data[key];
        row.hidden = value == null || String(value).trim() === '';
        row.querySelector('[data-rod-field]').textContent = value == null ? '' : value;
      });
    }
    section.addEventListener('variant:changed', event => {
      const variant = event.detail?.variant;
      update(variant);
      if (!variant) return;
      queueMicrotask(() => {
        const url = new URL(window.location.href);
        for (const [key, value] of preserved) {
          if (key !== 'variant') url.searchParams.set(key, value);
        }
        url.searchParams.set('variant', String(variant.id));
        history.replaceState(history.state, '', url.href);
      });
    });
    const node = section.querySelector('[data-product-json]');
    if (node) {
      try {
        const data = JSON.parse(node.textContent);
        update(data.product.variants.find(v => String(v.id) === String(data.selected_variant_id)));
      } catch { }
    }
  }
  document.querySelectorAll('[data-jootti-rod-panel]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-jootti-rod-panel]').forEach(init));
})();
